import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import Swal from "sweetalert2";

const ChangePasswordModal = ({ show, onClose, heading, initialData = {}, onSubmit }) => {
    const [formData, setFormData] = useState({
        user_id: "",
        password: "",
        confirmPassword: "",
    });

    useEffect(() => {
            if (initialData) {
                setFormData({
                    user_id: initialData.id,
                });
            }
        }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            alert("Password and confirm password do not match.");
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/branchUsers/change-password`, {
                user_id: formData.user_id,
                password: formData.password,
            });
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Password changed Successfully',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            onClose(); // Close modal on success
        } catch (error) {
            alert(error.response?.data?.error || "Something went wrong!");
        }
    };

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-12 mb-3">
                        <input type="hidden" name="user_id" value={formData.user_id}/>
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-12 mb-3">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn btn-light me-2" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save Changes
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ChangePasswordModal;
